import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useScroll"] */ "/app/node_modules/motion/dist/es/motion/lib/react.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Gallery"] */ "/app/src/app/culture/_components/events-section/components/gallery/gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuoteSection"] */ "/app/src/app/culture/_components/quote-section/quote-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/culture/_components/values-section/components/cards-desktop/cards-desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ValueCardDesktop"] */ "/app/src/app/culture/_components/values-section/components/value-card/value-card-desktop.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/carousel-card/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselSlide"] */ "/app/src/components/carousel/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/hero-image/hero-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroText"] */ "/app/src/components/hero-text/hero-text-props.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ParallaxContainer"] */ "/app/src/components/parallax/components/parallax-container.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/parallax/components/parallax-context.ts");
;
import(/* webpackMode: "eager" */ "/app/src/components/parallax/components/parallax-layer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ParallaxOverlay"] */ "/app/src/components/parallax/components/parallax-overlay.tsx");
